import { render, staticRenderFns } from "./businessItem.vue?vue&type=template&id=72304821&scoped=true"
import script from "./businessItem.vue?vue&type=script&lang=js"
export * from "./businessItem.vue?vue&type=script&lang=js"
import style0 from "./businessItem.vue?vue&type=style&index=0&id=72304821&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72304821",
  null
  
)

export default component.exports